import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { css, Icon, } from "./apihandler";
import CampSelectionPage from "./campselectionpage";
import TechniciansPage from "./technicianpage";
import WorkProgressPage from "./workprogresspage";
import PaymentPage from "./paymentpage";
// import OnboardingPage from "./onboardingpage";
import PricingConfigurationPage from "./pricingconfigurationpage";

export default function ResourceManagementDashboard() {
  const [tab, setTab] = useState(0);
  const [unlocked, setUnlocked] = useState(0);
  const [selectedCamp, setSelectedCamp] = useState(null);
  const [selectedTechnician, setSelectedTechnician] = useState(null);
  const navigate = useNavigate();

  const goTo = (index) => {
    if (index <= unlocked) {
      setTab(index);
    }
  };

  const confirmCamp = () => {
    if (!selectedCamp) return;

    setUnlocked(navItems.length - 1);
    setTab(1); // Go to Technicians
  };

  const navItems = [
    { label: "Camp", icon: "mapPin" },
    { label: "Technicians", icon: "users" },
    { label: "Pricing", icon: "dollar" },
    { label: "Work Progress", icon: "activity" },
    { label: "Payment", icon: "receipt" },
 ];

  const handleLogout = () => {

    localStorage.clear();

    navigate("/login");
  };

  return (
    <>
      <style>{css}</style>

      <div className="app">
        {/* Navigation */}
        <div className="nav">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%"
            }}
          >
            {/* Left Side */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                flex: 1
              }}
            >
              <div className="nav-brand">
                <Icon n="stethoscope" size={18} />
                <span>Resource Management Dashboard</span>
              </div>

              {navItems.map((item, index) => (
                <div
                  key={index}
                  className={`nt ${
                    tab === index ? "active" : ""
                  } ${index > unlocked ? "disabled" : ""}`}
                  onClick={() => goTo(index)}
                >
                  <Icon n={item.icon} size={15} />
                  {item.label}
                  <span className="nt-badge">
                    {index + 1}
                  </span>
                </div>
              ))}
            </div>

            {/* Right Side */}
            <button
              onClick={handleLogout}
              style={{
                background: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "8px 16px",
                cursor: "pointer",
                fontWeight: 600
              }}
            >
              🚪 Logout
            </button>
          </div>

          {/* {navItems.map((item, index) => (
            <div
              key={index}
              className={`nt ${
                tab === index ? "active" : ""
              } ${index > unlocked ? "disabled" : ""}`}
              onClick={() => goTo(index)}
            >
              <Icon n={item.icon} size={15} />
              {item.label}
              <span className="nt-badge">
                {index + 1}
              </span>
            </div>
          ))} */}
        </div>

        {/* Page Content */}
        {/* Camp */}
        {tab === 0 && (
        <CampSelectionPage
            selectedCamp={selectedCamp}
            onSelect={setSelectedCamp}
            onConfirm={confirmCamp}
        />
        )}

        {/* Onboarding
        {tab === 1 && selectedCamp && (
        <OnboardingPage
            camp={selectedCamp}
            onBack={() => setTab(0)}
            onNext={() => setTab(2)}
        />
        )} */}

        {/* Technicians */}
        {tab === 1 && selectedCamp && (
        <TechniciansPage
            camp={selectedCamp}
            onBack={() => setTab(0)}
            onNext={() => setTab(3)}
            onSelectTechnician={(tech) => {
                setSelectedTechnician(tech);
                setTab(2); // Open Pricing page immediately
            }}
        />
        )}

        {tab === 2 &&
        selectedCamp &&
        selectedTechnician && (
            <PricingConfigurationPage
            technicianId={selectedTechnician.technicianId}
            campId={selectedTechnician.campId}
            serviceId={selectedTechnician.serviceId}
            camp={selectedCamp}
            technician={selectedTechnician}
            onBack={() => setTab(1)}
            onNext={() => setTab(3)}
            />
        )}

        {/* Work Progress */}
        {tab === 3 && selectedCamp && (
        <WorkProgressPage
            camp={selectedCamp}
            onBack={() => setTab(2)}
            onNext={() => setTab(4)}
        />
        )}

        {/* Payment */}
        {tab === 4 && selectedCamp && (
        <PaymentPage
            camp={selectedCamp}
            onBack={() => setTab(3)}
        />
        )}


      </div>
    </>
  );
}